import React, {useContext} from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {useHistory} from "react-router-dom";

import {Box, Skeleton} from "@mui/material";

import Badge from "components/Badge";

import {
    blue700,
    green700,
    greyishBlue50,
    greyishBlue100,
    greyishBlue500,
    greyishBlue600,
    greyishBlue700,
    orange700,
    red700,
    black500,
} from "assets/jss/main";

import {DateRangePickerContext} from "contexts/DateRangePickerContext";
import {LineItemStatus} from "utils/LineItemStatus";
import {OMSRoutes} from "utils/OMSRoutes";
import {UserAgentUtils} from "utils/useragent";

function OrderStatuses({ statusCount, loading }) {
    const history = useHistory();
    const {startDate, endDate} = useContext(DateRangePickerContext);

    const isMobile = UserAgentUtils.isMobile();

    return (
        <Box>
            <div style={{
                color: isMobile ? black500 : greyishBlue600,
                fontSize: isMobile ? '18px' : '14px',
                fontWeight: isMobile ? 700 : 400,
                marginBottom: "16px"
            }}>
                <FormattedMessage id="dashboard.orderStatuses.title" />
            </div>
            <Box sx={{ display: "flex", flexWrap: "nowrap", gap: 1, overflowX: "auto", pb: 0.5 }}>
                {loading ? [1,2,3,4,5,6].map((key) => (
                    <Skeleton
                        key={key}
                        variant="rounded"
                        width={120}
                        height={36}
                        sx={{ borderRadius: "8px" }}
                    />
                )) : (
                    <>
                        <Badge
                            onClick={() => history.push(OMSRoutes.ORDER_LIST_STATUS(LineItemStatus.PENDING, startDate, endDate))}
                            color={'outline'}
                            labelColor={greyishBlue700}
                            backgroundColor={greyishBlue50}
                            indicatorColor={greyishBlue500}
                            borderColor={greyishBlue100}
                            border={true}
                            size={'xl'}
                            indicator={'circle'}
                            labelSize={14}
                            isBold={false}
                            rounded={'soft'}
                        >
                            <><b>{statusCount[LineItemStatus.PENDING] ?? 0}</b> <FormattedMessage id='dashboard.onlineOrders.label.pending' /></>
                        </Badge>
                        <Badge
                            onClick={() => history.push(OMSRoutes.ORDER_LIST_STATUS(LineItemStatus.RESERVED, startDate, endDate))}
                            color={'outline'}
                            backgroundColor={'#FEF3E3'}
                            labelColor={'#925701'}
                            indicatorColor={'#EA9310'}
                            borderColor={'#EDDFCA'}
                            border={true}
                            size={'xl'}
                            indicator={'circle'}
                            labelSize={14}
                            isBold={false}
                            rounded={'soft'}
                        >
                            <><b>{statusCount[LineItemStatus.RESERVED] ?? 0}</b> <FormattedMessage id='dashboard.onlineOrders.label.reserved' /></>
                        </Badge>
                        <Badge
                            onClick={() => history.push(OMSRoutes.ORDER_LIST_STATUS(LineItemStatus.TO_SHIP, startDate, endDate))}
                            color={'default'}
                            labelColor={blue700}
                            border={true}
                            size={'xl'}
                            indicator={'circle'}
                            labelSize={14}
                            isBold={false}
                            rounded={'soft'}
                        >
                            <><b>{statusCount[LineItemStatus.TO_SHIP] ?? 0}</b> <FormattedMessage id='dashboard.onlineOrders.label.toShip' /></>
                        </Badge>
                        <Badge
                            onClick={() => history.push(OMSRoutes.ORDER_LIST_STATUS(LineItemStatus.CONFIRMED, startDate, endDate))}
                            color={'online'}
                            labelColor={green700}
                            border={true}
                            size={'xl'}
                            indicator={'circle'}
                            labelSize={14}
                            isBold={false}
                            rounded={'soft'}
                        >
                            <><b>{statusCount[LineItemStatus.CONFIRMED] ?? 0}</b> <FormattedMessage id='dashboard.onlineOrders.label.confirmed' /></>
                        </Badge>
                        <Badge
                            onClick={() => history.push(OMSRoutes.ORDER_LIST_STATUS('returning', startDate, endDate))}
                            color={'warning'}
                            labelColor={orange700}
                            border={true}
                            size={'xl'}
                            indicator={'circle'}
                            labelSize={14}
                            isBold={false}
                            rounded={'soft'}
                        >
                            <><b>{statusCount['returning'] ?? 0}</b> <FormattedMessage id='dashboard.onlineOrders.label.returning' /></>
                        </Badge>
                        <Badge
                            onClick={() => history.push(OMSRoutes.ORDER_LIST_STATUS(LineItemStatus.CANCELED, startDate, endDate))}
                            color={'error'}
                            labelColor={red700}
                            border={true}
                            size={'xl'}
                            indicator={'circle'}
                            labelSize={14}
                            isBold={false}
                            rounded={'soft'}
                        >
                            <><b>{statusCount[LineItemStatus.CANCELED] ?? 0}</b> <FormattedMessage id='dashboard.onlineOrders.label.canceled' /></>
                        </Badge>
                    </>
                )}
            </Box>
        </Box>
    );
}

OrderStatuses.propTypes = {
    statusCount: PropTypes.object,
    loading: PropTypes.bool,
};

export default OrderStatuses;
